import { z } from "zod";

export const AdditionalI18nFieldsSchema = z.object({
  id: z.number(),
  source: z.string(),
  target: z.string(),
  lang: z.string(),
});
export const PartialAdditionalI18nFieldsSchema =
  AdditionalI18nFieldsSchema.deepPartial();

export type AdditionalI18nFields = z.infer<typeof AdditionalI18nFieldsSchema>;
export type PartialAdditionalI18nFields = z.infer<
  typeof PartialAdditionalI18nFieldsSchema
>;
export type AdditionalI18n = z.infer<typeof AdditionalI18nFieldsSchema>;
